import dayjs from 'dayjs';

export const isFuture = date => {
  return dayjs(date).diff(dayjs(), 'seconds') > 0;
};

export const isPast = date => {
  return dayjs(date).diff(dayjs(), 'minutes') <= 0;
};

export const isBefore = (date1, date2, unitTime = 'minutes') => {
  return dayjs(date1).diff(dayjs(date2), unitTime) < 0;
};

export const isAfter = (date1, date2, unitTime = 'minutes') => {
  return dayjs(date1).diff(dayjs(date2), unitTime) > 0;
};

export const getDueDateDiffInDays = dueDate => {
  return dayjs(dueDate).diff(dayjs(), 'days');
};

export const getDueDateDiffInNaturalDays = dueDate => {
  return Math.ceil(dayjs(dueDate).diff(dayjs(), 'days', true));
};

export const getDueDateDiffInHours = dueDate => {
  return dayjs(dueDate).diff(dayjs(), 'hours');
};

export const getDueDateDiffInNaturalHours = dueDate => {
  return Math.round(dayjs(dueDate).diff(dayjs(), 'hours', true));
};

export const getDueDateDiffInMinutes = dueDate => {
  return dayjs(dueDate).diff(dayjs(), 'minutes');
};
